import { render, staticRenderFns } from "./BaseInput.vue?vue&type=template&id=bc0d77bc&scoped=true&"
import script from "./BaseInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseInput.vue?vue&type=style&index=0&id=bc0d77bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0d77bc",
  null
  
)

export default component.exports